import { Container, Row, Col } from "react-bootstrap";
import TrackVisibility from 'react-on-screen';
import AboutImg from "../assets/img/about-img.jpg";

export const About = () => {
  return (

    <section className="about" id="about">
      <Container>
        <h2>About Me</h2>
        <Row className="align-items-center">

          <Col xs={6} md={3} xl={2}>
            <TrackVisibility>
              {({ isVisible }) =>

                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={AboutImg} alt="Header Img"/>
                </div>}
                
            </TrackVisibility>
          </Col>
          
          <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>

              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>                   
                <p className="about-desc">"I am an undergraduate student majoring in Information Technology at the University of Colombo School of Computing, External Degree Center. My vision is to embark on a successful career in the field of software engineering. I specialize in developing modern websites, mobile applications, and programs using popular programming languages." </p>            
              </div>}
            </TrackVisibility>
          </Col>

        </Row>
      </Container>
    </section>
    );
}